import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ShareTrackingURLModalComponent } from './share-tracking-modal.component';
import { FormErrorModule } from '../../form-error/module';

const COMPONENTS = [ShareTrackingURLModalComponent];

@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    FormErrorModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class ShareTrackingModalModule {}
